"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartPieFull = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ChartPieFull = function ChartPieFull(_a) {
  var id = _a.id;
  var clipPathId = id ? "ChartPieFull__clip0__".concat(id) : 'ChartPieFull__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.287 10.178V.608a.56.56 0 01.217-.462.54.54 0 01.482-.134c5.144.83 9.177 4.89 10.002 10.069a.55.55 0 01-.133.486.554.554 0 01-.458.218H13.89a.605.605 0 01-.603-.607zm10.11 3.036H13.89a.605.605 0 00-.603.608v9.57a.56.56 0 00.217.462c.13.121.31.171.482.134 5.144-.83 9.177-4.891 10.002-10.069a.55.55 0 00-.133-.486.554.554 0 00-.458-.219zM0 12C0 6.045 4.288.969 10.126.012h.048a.54.54 0 01.434.134.56.56 0 01.217.461v22.786a.56.56 0 01-.217.461.54.54 0 01-.482.134C4.288 23.03 0 17.954 0 12z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.ChartPieFull = ChartPieFull;